export default __webpack_public_path__ + "static/media/laboratrist.3e09472a.jpg";